namespace Gordic.Epk.WebControls.Vyrizeni {



    //#region *** NOTIFICATION SENDER ***

    export class NotificationSender {

        public sendCustom(_cnt, text: string) {

            var cnt: GContentType<GEpkDbParamsNew> = _cnt;

            cnt.notification("add", {
                state: "success",
                group: "jres:32000132", //RC 32000132 : Událost
                title: "jres:32000133", //RC 32000133 : Upozornění
                icon: "gi-tick g-state-text g-state-success",
                content: text,
                dateTime: new Date()
            });

        }

        public send(_cnt, params: IVyrizeniEpkParams, state: "success" | "fail", reasonResponse?: IGReasonResponse) {

            var cnt: GContentType<GEpkDbParamsNew> = _cnt;

            // jedná-li se content detailu žádosti, který se zavře, tak se přesunu na content seznamu a z něj vyvolám notifikaci
            // pokud by se detaily nezavírali a přesouvali se na další, musel bych asi upravit logiku, asi na nějaký příznak
            if (cnt.className === "Gordic.Epk.WebControls.GEpkDetail" && cnt.parentContent != null) {
                cnt = (cnt.parentContent as any);
            }

            console.log("%cSendRequestNotification", "color: yellow;");

            setTimeout(() => {

                var icon = state === "success" ?
                    "gi-tick g-state-text g-state-success" :
                    "fa-times g-state-text g-state-error";

                var content = "";
                if (state === "success") {
                    content = this.init(params);
                }
                else {
                    content = "jres:32000932 " + //RC 32000932 : Vyřízení žádosti
                              params.ixp +
                              " jres:32000933"; //RC 32000933 : selhalo.
                }

                cnt.notification("add", {
                    state: "success",
                    group: "jres:32000132", //RC 32000132 : Událost
                    title: "jres:32000133", //RC 32000133 : Upozornění
                    icon: icon,
                    content: content,
                    dateTime: new Date(),
                    defaultAction: new GAction({
                        name: "showActNoficationDetail",
                        run: (ev, ctx) => {
                            if (reasonResponse != null) {
                                const main = $("<div>");
                                if (reasonResponse != null && reasonResponse["reasonlong"] != null) 
                                    $("<div>").html(reasonResponse["reasonlong"]).appendTo(main);
                                $.content().dialogs.error("LOG", main);
                            }
                            else {
                                var options = {
                                    Ixp: params.ixp,
                                    CelyUrad: false,
                                    SerCislo: params.serCislo,
                                };
                                Gordic.Epk.Dialogs.DetailZadostiDlg($.content(), options, Gordic.Gin.Globals.Enums.ModOtevreni.navigate);
                            }

                        }
                    })
                });
            }, 500);

        }

        private init(params: IVyrizeniEpkParams) {

            /** zpráva notifikace */
            var txt = "";
            /** identifikátor ixp */
            var ixp = params.ixp;

            var typPozadavku = params.typPozadavku;
            var docText = "jres:32000655"; //RC 32000655 : Dokument/Spis

            // zamítnuto
            if (params.zpusobVyrizeni === Gordic.Wfl.Interface.GWflczpvEnum.VracenoKPrepracovani) {
                txt = docText + " " + ixp + " jres:32000443"; //RC 32000443 : byl úspěšně vrácen k přepracování.
            }
            // povoleno
            else {

                if (typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.SchvalitVyrizeniSpisu) {
                    txt = "jres:32000645 " + ixp +  //RC 32000645 : Schválení vyřízení spisu
                        " jres:32000646";         //RC 32000646 : bylo úspěšně provedeno.
                }
                else if (typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.Prideleni) {
                    txt = "jres:32000636 " +        //RC 32000636 : Přidělení
                          "jres:32000656 " +        //RC 32000656 : Dokumentu/Spisu
                            ixp +                     
                          " jres:32000637";         //RC 32000637 : bylo úspěšně schváleno
                }
                else if (typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.Predani) {
                    txt = "jres:32000638 " +        //RC 32000638 : Předání
                          "jres:32000656 " +        //RC 32000656 : Dokumentu/Spisu
                            ixp +  
                          " jres:32000637";         //RC 32000637 : bylo úspěšně schváleno
                }
                else if (typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.Podepsat) {
                    txt = docText + " " + ixp + " jres:32000442"; //RC 32000442 : byl úspěšně podepsán.
                }
                else if (typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit) {
                    txt = docText + " " + ixp + " jres:32000441"; //RC 32000441 : byl úspěšně podepsán a schválen.
                }
                else if (typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.Schvalit) {
                    txt = docText + " " + ixp + " jres:32000440"; //RC 32000440 : byl úspěšně schválen.
                }
                else if (typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.Posoudit) {
                    txt = docText + " " + ixp + " jres:32000439"; //RC 32000439 : byl úspěšně posouzen.
                }
                else if (typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.VzitNaVedomi) {
                    txt = docText + " " + ixp + " jres:32000438"; //RC 32000438 : byl úspěšně vzat na vědomí.
                }
                // Specialita pro Ukrajinu
                else if (typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.Splnit) {
                    //RC 32000452 : Žádost dokumentu
                    //RC 32000429 : Splnit
                    //RC 32000453 : byla úspěšně vyřízena.
                    txt = "jres:32000452 " + ixp + " 'jres:32000429' " + "jres:32000453";
                }
                else if (typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.Rozhodnout) {
                    //RC 32000452 : Žádost dokumentu
                    //RC 32000450 : Rozhodnout
                    //RC 32000453 : byla úspěšně vyřízena.
                    txt = "jres:32000452 " + ixp + " 'jres:32000450' " + "jres:32000453";
                }
                else {
                    console.log("Neznámý typ požadavku.");
                }

            }
            return txt;
        }

    }

    //#endregion


}